import { isEmpty, path, pathOr } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingActivityFetch = state => path(['activity', 'pendingFetch'], state);
export const getPendingActivityCreate = state => path(['activity', 'pendingCreate'], state);
export const getPendingActivityUpdate = state => path(['activity', 'pendingUpdate'], state);
export const getPendingActivityDelete = state => path(['activity', 'pendingDelete'], state);
export const getPendingActivities = state => ({
	fetch: getPendingActivityFetch(state),
	create: getPendingActivityCreate(state),
	update: getPendingActivityUpdate(state),
	delete: getPendingActivityDelete(state),
});
export const getDirtyActivities = state => path(['activity', 'isDirty'], state);
export const getActivityErrorFetch = state => path(['activity', 'fetchError'], state);
export const getActivityErrorCreate = state => path(['activity', 'createError'], state);
export const getActivityErrorUpdate = state => path(['activity', 'updateError'], state);
export const getActivityErrorDelete = state => path(['activity', 'deleteError'], state);
export const getActivityErrors = state => ({
	fetch: getActivityErrorFetch(state),
	create: getActivityErrorCreate(state),
	update: getActivityErrorUpdate(state),
	delete: getActivityErrorDelete(state),
});
export const getEntities = state => path(['activity', 'entities'], state);
export const getActivities = createSelector(getEntities, entities => Object.values(entities));
export const getActivitiesWithValidConstituent = createSelector(getActivities, activities =>
	activities.filter(activity => Boolean(activity.constituent) && !isEmpty(activity.constituent)),
);
export const getTotal = state => path(['activity', 'totalToDisplay'], state);
export const getActivityById = (state, id) => pathOr({}, ['activity', 'entities'], state)[id];
export const getSkip = state => path(['activity', 'skip'], state);
export const getActivitiesToday = state => path(['activity', 'activitiesToday'], state);
export const getActivitiesThisWeek = state => path(['activity', 'activitiesThisWeek'], state);



// WEBPACK FOOTER //
// ./src/redux/activities/activity.selector.js